import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuseCreateTaskComponent } from '@fuse/components/create-task/create-task.component';
import { TableModule } from 'primeng/table';
import { CalendarModule } from 'primeng/calendar';
import { SliderModule } from 'primeng/slider';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContextMenuModule } from 'primeng/contextmenu';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { DropdownModule } from 'primeng/dropdown';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import {MatDatepickerModule} from "@angular/material/datepicker";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FuseSelectSearchPipeModule } from '@fuse/pipes/select-search';
import { TranslocoModule } from '@ngneat/transloco';



@NgModule({
    declarations: [
        FuseCreateTaskComponent,
    ],
    imports     : [
        CommonModule,
        TableModule,
        CalendarModule,
        SliderModule,
        DialogModule,
        MultiSelectModule,
        ContextMenuModule,
        ButtonModule,
        ToastModule,
        InputTextModule,
        ProgressBarModule,
        DropdownModule,
        SplitButtonModule,
        MatMenuModule,
        MatIconModule,
        FormsModule,
        MatDialogModule,
        MatDatepickerModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatButtonModule,
        FuseSelectSearchPipeModule,
        TranslocoModule

    ],
    exports     : [
        FuseCreateTaskComponent,
    ],
    providers   :[
    ]
})
export class FuseCreateTaskModule
{
}
